import React from "react";
import Motion from "../utils/Motion";

const _404 = () => {
  return <Motion>_404</Motion>;
};

export default _404;
